import { get } from 'lodash'

/**
 * 判斷 CYJ POS 票券是否符合手動核銷條件
 * @param {Object} couponRecord - 票券紀錄
 * @returns {boolean}
 */
export const canManuallyRedeemCyjPosCoupon = (couponRecord) => {
  const cyjPosConfig = get(couponRecord, 'Coupon.extraSetting.cyjPosConfig', {})

  return /^\d+$/.test(cyjPosConfig.linkItemCode) && String(cyjPosConfig.couponDisType) === '3'
}
